import { RouteRecordRaw } from 'vue-router'

export const senndriveRoutes: RouteRecordRaw[] = [
  {
    path: '/senndrive',
    name: 'Senndrive',
    component: () => import('./index'),
    meta: {
      layout: 'AppLayoutDefault',
      middlewares: [],
    },
  },
  {
    path: '/activities',
    redirect: '/senndrive',
  },
]
